import { AverageBy, ExportFormat, HeaderLayout, LayoutAxis } from '../api/dashboard';
import i18n from '../i18n';

export interface Choice<T> {
  name: string;
  value: T;
}

export const formatChoices: Choice<ExportFormat>[] = [
  { name: 'Excel (.xlsx)', value: ExportFormat.EXCEL },
  { name: 'CSV (.csv)', value: ExportFormat.CSV },
];

export const layoutAxisChoices: Choice<LayoutAxis>[] = [
  { get name() { return i18n.t('Own column (default)')(); }, value: LayoutAxis.COLUMN },
  { get name() { return i18n.t('Own row')(); }, value: LayoutAxis.ROW },
];

export const headerLayoutChoices: Choice<HeaderLayout>[] = [
  { get name() { return i18n.t('Own row (default)')(); }, value: HeaderLayout.OWN_ROW },
  {
    get name() { return i18n.t('Include default headers in trait name')(); },
    value: HeaderLayout.INCLUDE_IN_TRAIT,
  },
  { get name() { return i18n.t('Hide trait group row')(); }, value: HeaderLayout.HIDE },
];

export const averageByChoices: Choice<AverageBy>[] = [
  { get name() { return i18n.t('Plot (default)')(); }, value: 'plot' },
  { get name() { return i18n.t('Site × Treatment')(); }, value: 'site_treatment' },
  { get name() { return i18n.t('Site')(); }, value: 'site' },
];

export const averageByTooltip = i18n.t(
  "Averaging applies to numeric and date traits. Numeric means use each trait's configured precision; traits without one keep the raw mean. Date traits are averaged across plots (mean of date ordinals). Non-numeric cells show the common value in the group, or stay empty if values differ."
);
